<template>
  <div>
    <div class="content py-5 px-6">
      <vs-row>
        <vs-col vs-w="11"></vs-col>
        <vs-col vs-w="1">
          <vs-button
            id="printPageButton"
            type="flat"
            icon-pack="feather"
            icon="icon-printer"
            @click="print()"
          >
            พิมพ์
          </vs-button>
        </vs-col>
      </vs-row>
      <header>
        <vs-row class="mt-5" vs-type="flex">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="text-center py-5"
          >
            <img
              class="-mt-2 mr-5"
              src="../../../../src/assets/excise/header_image.jpg"
              width="100%"
              height="full"
            />
          </vs-col>
        </vs-row>
        <vs-row class="-mt-4 mb-10 pr-10 text-right">
          <vs-col >
            {{installationCode}}
          </vs-col>
        </vs-row>
      </header>
      <div class="content-block">
        <h3 align="center">แบบฟอร์มการติดตั้งอุปกรณ์</h3>
        <p class="mt-10">ส่วนที่ 1 ผู้ยื่นคำขอ(เจ้าของเรือ)</p>

        <vs-row class="mt-5 ml-5">
          <div class="flex ml-5">
            <vs-radio
              disabled
              class="mr-5"
              v-model="checkbox"
              vs-value="chkPerson"
              >บุคคลธรรมดา</vs-radio
            >
            <vs-radio
              disabled
              class="mr-5"
              v-model="checkbox"
              vs-value="chkLegal"
              >นิติบุคคล</vs-radio
            >
            <vs-radio
              disabled
              class="mr-10"
              v-model="checkbox"
              vs-value="chkOther"
              >อื่นๆ โปรดระบุ</vs-radio
            >
            <p class="mt-2 mx-2" v-show="checkbox == 'chkOther'">ระบุ</p>
            <vs-input disabled class="w-auto" v-show="checkbox == 'chkOther'" />
          </div>

          <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <p>
              ชื่อ :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateOperateName
                  : `${info.firstName} ${info.lastName}`
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <p>เลขบัตรประจำตัวประชาชน / เลขนิติบุคคล : {{ info.cardNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>เลขรหัสประจำบ้าน : {{ info.houseCodeNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12" v-if="info.personType == 'นิติบุคคล'">
            <p>ที่ตั้งสำนักงานใหญ่เลขที่ : {{ info.registrationOffice }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชื่ออาคาร : {{ info.buildingName }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>เลขที่ : {{ info.address }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชั้นที่ : {{ info.floor }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>
              ตำบล :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateSubDistrict
                  : info.subDistrict
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>
              อำเภอ/เขต :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateDistrict
                  : info.district
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>
              จังหวัด :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateProvince
                  : info.province
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>
              รหัสไปรษณีย์ :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificatePostalCode
                  : info.postalCode
              }}
            </p>
          </vs-col>

          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>
              โทรศัพท์ :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificatePhoneNumber
                  : info.phoneNumber
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>
              อีเมล :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateEmail
                  : info.email
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ชื่อเรือ : {{ vessel.name }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>หมายเลขทะเบียนเรือ : {{ vessel.registrationNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ชื่อเรียกขาน (Call Sign) : {{ vessel.subName }}</p>
          </vs-col>

          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>วัสดุตัวเรือ : {{ vessel.material }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ขนาดเรือ ความยาวตลอดลําเมตร : {{ vessel.size }} เมตร</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ความกว้าง : {{ vessel.width }} เมตร</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ความลึก : {{ vessel.depth }} เมตร</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ตันกรอส : {{ vessel.tonGross }} ตันเนตชนิด</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>เครื่องจักร : {{}}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชื่อเครื่อง : {{ vessel.machineName }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>จำนวนเครื่อง : {{ vessel.machineNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>จำนวนสูบ : {{ vessel.engineNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>ขนาดเครื่องยนต์ : {{ vessel.engineSize }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="8" vs-sm="12" vs-xs="12">
            <p>
              ปริมารตรความจุถังน้ำมัน (ใช้สำหรับเรือ) :
              {{ vessel.capacity }} ลิตร
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <p>
              ปริมารตรความจุถังน้ำมัน (กรณีเรือบรรทุกน้ำมัน /
              เรือสถานีบริการจำหน่ายน้ำมัน) : {{ vessel.capacityForSale }} ลิตร
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ประเภทการใช้ : {{ vessel.usageType }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>
              ใบอนุญาตใช้เรือจดทะเบียนล่าสุดวันที่ :
              {{ formateDate(vessel.licenseExpireDate) }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ประเภทเรือ : {{ vessel.vesselType }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>หมดอายุวันที่ : {{ formateDate(vessel.expireDate) }}</p>
          </vs-col>
        </vs-row>

        <!-- <vs-row class="mt-5 w-full">
          <vs-divider />
        </vs-row> -->
      </div>

      <div class="content-block">
        <p class="mt-10">
          ส่วนที่ 2 ภาพรายละเอียดอุปกรณ์ที่ติดตั้ง หรือแนบรูปเพิ่มเติม
        </p>
        <div class="vx-row mt-10 mx-auto">
          <div class="vx-col w-1/2 mb-10" align="center">
            <img :src="this.imageNameUrl" max-width="350" height="200" />
            <h6 class="mt-5">รูปที่ 1 ชื่อเรือ / เลขทะเบียนเรือ</h6>
          </div>
          <div class="vx-col w-1/2 mb-10" align="center">
            <img :src="this.imageAISDevice" max-width="350" height="200" />
            <h6 class="mt-5">รูปที่ 2 อุปกรณ์ AIS Device</h6>
          </div>
          <div class="vx-col w-1/2 mb-5" align="center">
            <img :src="this.imageVHFAntenna" max-width="350" height="200" />
            <h6 class="mt-5">รูปที่ 3 อุปกรณ์ VHF Antenna</h6>
          </div>
          <div class="vx-col w-1/2 mb-5" align="center">
            <img :src="this.imageGPSAntena" max-width="350" height="200" />
            <h6 class="mt-5">รูปที่ 4 อุปกรณ์ GPS Antenna</h6>
          </div>
        </div>

        <!-- <vs-row class="w-full mb-20">
          <vs-divider />
        </vs-row> -->
      </div>

      <div class="content-block">
        <div class="mx-20 mt-20 mb-20">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ข้าพเจ้าขอรับรองว่าข้อความในแบบคำขอที่ยื่นมานี้มีความถูกต้องและเป็นจริงทุกประการ
            ตลอดจนจะปฏิบัติตามกฎหมายและระเบียบของทางราชการทุกประการ
            และเมื่อได้รับการติดตั้งอุปกรณ์ระบบสำแดงข้อมูลตัวตนอัตโนมัติ
            (Automatic Identification System : AIS) จากกรมสรรพสามิตแล้ว
            ข้าพเจ้าจะดูแลรักษาอุปกรณ์ระบบฯ ดังกล่าวเป็นอย่างดี
            และหากเกิดการชำรุดเสียหายอันเกิดจากความประมาทเลินเล่อในการปฏิบัติงาน
            ข้าพเจ้ายินยอมชดใช้ค่าเสียหายและค่าซ่อมแซมอุปกรณ์ระบบฯ
            ให้แก่กรมสรรพสามิต
          </p>
        </div>

        <vs-row class="mb-10">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <img
              :src="this.imageSignatureAdminUrl"
              width="25%"
              v-if="imageSignatureAdminUrl"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <span class="flex">
              <p>ลงชื่อ</p>
              <p>
                ........................................................................
              </p>
              <p>(ผู้ติดตั้งอุปกรณ์)</p>
            </span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>(บริษัท เปรม กรุ๊ป เอ็นจิเนียริ่ง จำกัด)</p>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>วันที่ {{ formateDate(new Date()) }}</p>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-10"
            v-if="companySealImage"
          >
            <img :src="companySealImage" height="100" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <img
              :src="this.imageSignatureUserUrl"
              width="25%"
              v-if="imageSignatureUserUrl"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="ml-20"
          >
            <span class="flex ml-20">
              <p>ลงชื่อ</p>
              <p>
                ........................................................................
              </p>
              <p>(ชื่อผู้ควบคุมเรือ/ไต๋เรือ/ผู้ทําการประมง)</p>
            </span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p v-if="checkbox == 'chkPerson'">
              ( {{ info.title }}{{ info.firstName }} {{ info.lastName }} )
            </p>
            <p v-else>( {{ info.certificateOperateName }} )</p>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>วันที่ {{ formateDate(registrationAt) }}</p>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p class="mt-20 mr-20">
              <b>หมายเหตุ :</b>
            </p>
            <br />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p class="mt-5 ml-20">พร้อมคู่มือการใช้งาน และคู่มือการติดตั้ง</p>
            <br />
          </vs-col>
        </vs-row>
        <!-- <vs-row class="w-full mt-5">
          <vs-divider />
        </vs-row> -->
      </div>

      <footer>
        <vs-row class="my-5" vs-type="flex">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="text-center py-5"
          >
            <img
              class="-mt-2 mr-5"
              src="../../../../src/assets/excise/footer_image.jpg"
              width="100%"
              height="full"
            />
          </vs-col>
        </vs-row>
      </footer>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Validator } from "vee-validate";
import { DICT_VESSEL, DICT_USER } from "../../../mock-data/form-validate.js";
import { ENDPOINT } from "../../../constants/endpoint";
import moment from "moment";
import _ from "lodash";

// register custom messages
Validator.localize("en", DICT_VESSEL, DICT_USER);

export default {
  props: {
    dataVessel: Object,
  },
  data() {
    return {
      vesselInfo: {},
      info: {
        address: null,
        buildingName: null,
        cardNumber: null,
        certificateDistrict: null,
        certificateEmail: null,
        certificateEstablishmentName: null,
        certificateJuristicNumber: null,
        certificateLane: null,
        certificateOperateName: null,
        certificatePhoneNumber: null,
        certificatePostalCode: null,
        certificateProvince: null,
        certificateRoad: null,
        certificateSubDistrict: null,
        certificateVillageNumber: null,
        createdAt: null,
        district: null,
        email: null,
        firstName: null,
        floor: null,
        houseCodeNumber: null,
        id: null,
        lane: null,
        lastName: null,
        password: null,
        personType: null,
        phoneNumber: null,
        postalCode: null,
        province: null,
        registrationOffice: null,
        road: null,
        status: null,
        subDistrict: null,
        title: null,
        updatedAt: null,
        username: null,
        villageNumber: null,
      },
      vessel: {
        capacity: null,
        capacityForSale: null,
        cardNumber: null,
        certificateDate: null,
        createdAt: null,
        depth: null,
        engineNumber: null,
        engineSize: null,
        expireDate: null,
        fisheriesLicense: null,
        id: null,
        imageAisUrl: null,
        imageDocumentUrl: null,
        imageLeftUrl: null,
        imageNameUrl: null,
        imageRightUrl: null,
        licenseExpireDate: null,
        licenseNumber: null,
        machineName: null,
        machineNumber: null,
        machineType: null,
        material: null,
        mmsi: null,
        name: null,
        objective: null,
        ownerName: null,
        portName: null,
        registrationNumber: null,
        size: null,
        subName: null,
        tonGross: null,
        tonNet: null,
        toolType: null,
        type: null,
        updatedAt: null,
        usageType: null,
        vesselType: null,
        width: null,
      },
      checkbox: null,
      imageNameUrl: null,
      imageAISDevice: null,
      imageVHFAntenna: null,
      imageGPSAntena: null,
      registrationAt: null,
      imageSignatureUserUrl: null,
      imageSignatureSupervisorUrl: null,
      imageSignatureObserverUrl: null,
      companySealImage: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch(
        `reparations/setVesselReparationById`,
        this.$route.params.id
      );

      const reparation = this.$store.state.reparations.selectedReparation
      this.installationCode = reparation.installationCode
      console.log("reparation ===> ", reparation.installations[0].signatures);

      this.info = reparation.reparationByUserId;
      this.vessel = reparation.vessel;
      // console.log("this is info :", this.info.personType);
      // console.log("this is vessel :", this.vessel);
      this.registrationAt = reparation.installations[0].createdAt;

      this.info.personType == "บุคคลทั่วไป"
        ? (this.checkbox = "chkPerson")
        : this.info.personType == "นิติบุคคล"
        ? (this.checkbox = "chkLegal")
        : (this.checkbox = "chkOther");

      this.imageNameUrl =
        ENDPOINT.GET_IMAGE_INSTALL + reparation.installations[0].imageNameUrl;
      for (const accessory of reparation.installations[0].accessories) {
        if (accessory.type == 1) {
          this.imageAISDevice = ENDPOINT.GET_IMAGE_INSTALL + accessory.imageUrl;
        } else if (accessory.type == 2) {
          this.imageVHFAntenna = ENDPOINT.GET_IMAGE_INSTALL + accessory.imageUrl;
        } else if(accessory.type == 3){
          this.imageGPSAntena = ENDPOINT.GET_IMAGE_INSTALL + accessory.imageUrl;
        }
      }
      console.log("this is ", this.imageNameUrl);

      if (reparation.installations[0].signatures.lenght != 0) {
        for (const signature of reparation.installations[0].signatures) {
          if (signature.type == "ผู้ยื่นคำขอ") {
            this.imageSignatureUserUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          if (signature.type == "ผู้ดูแลระบบ") {
            this.imageSignatureAdminUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          if (signature.type == "เจ้าพนักงานสรรพสามิต") {
            this.imageSignatureSupervisorUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          if (signature.type == "ผู้บริหาร") {
            this.imageSignatureObserverUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
        }
      }
      const companySeal =  this.checkbox != "chkPerson" && _.find(reparation.createdBy.documents, { 'type': 8 });
      if (companySeal) {
        this.companySealImage = ENDPOINT.GET_IMAGE_COMPANY_SEAL + companySeal.fileName
      }
    },
    formateDate(date) {
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-color: white;
}

.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}

@page {
  // size: A4;
  // margin: 11mm 17mm 17mm 17mm;
  size: auto;
  margin: 0mm;
}

@media print {
  #printPageButton {
    display: none;
  }

  footer {
    position: fixed;
    bottom: 0;
  }

  header {
    position: fixed;
    top: 0;
  }
  .content-block {
    padding-top: 170px;
  }
  .content-block,
  p {
    page-break-inside: avoid;
  }
}
</style>
